import axios from 'axios';
import { APIURL } from '../../_config';
import { handleInvalidToken, setIsInactive } from './slices/AppSlice';
import { ACCOUNT_INACTIVE, LOCAL_STORAGE_KEYS, UNAUTHENTICATED, UNAUTHORIZED } from 'src/lib/constants';
import { loadState } from 'src/lib/utils';

const APIService = axios.create({
  baseURL: APIURL('/api'),
});

// Initialize without store import
let storeDispatch = null;

export const injectStore = (dispatch) => {
  storeDispatch = dispatch;
};

APIService.interceptors.request.use(
  async (config) => {
    const token = loadState(LOCAL_STORAGE_KEYS.token);
    if (token) {
      config.headers.accessToken = token;
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

APIService.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const message = error?.response?.data?.message;

    if (message === UNAUTHORIZED && storeDispatch) {
      storeDispatch(handleInvalidToken(true));
      return Promise.reject(error);
    }

    if (message === ACCOUNT_INACTIVE && storeDispatch) {
      storeDispatch(setIsInactive(true));
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

export default APIService;